import Alert from "@material-ui/lab/Alert";
import axios from "axios";
import React, { useState } from "react";
import { check2FA } from "../../../../../utils/check2FA";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../../utils/consts";
import getUserInfo from "../../../../../utils/getUserInfo";
import { parseAxiosError } from "../../../../../utils/response";
import { TimestampToDateMoment } from "../../../../../utils/timestampToDate";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";
import DialogModal from "../../../../elements/dialogModal/DialogModal";
import Notification from "../../../../elements/notification/Notification";
import PageSpinner from "../../../../elements/spinner/PageSpinner";
import TwoFa from "../../../../elements/twoFa/TwoFa";
import MaterialSwitch from "../../../../styles/materialSwitch";

import { StyledCol, StyledTable, StyledTableHead, StyledTableRow } from "../../../../styles/styledTable";

const ConnectionsList = ({ t, connections, fetchConnections }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});
  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });
  const [changeConnection, setChangeConnection] = useState({
    id: null
  });

  const handleSubmit = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.put("/api/connections/" + changeConnection.id, changeConnection, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        fetchConnections();

        setOpen(false);

        setChangeConnection({ id: null });

        setNotification({
          ...notification,
          visible: true,
          type: "success",
          message: t("details.connections.success")
        });
      }
    }).catch(error => {
      setOpen(false);

      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  if (!connections) {
    return <PageSpinner
      position="center"
      pt="60"
      pb="60"
    />;
  }

  if (!connections.length) {
    return <Alert severity="warning">
      {t("details.connections.noConnections")}
    </Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.connections.twoFa")}
        content={<TwoFa
          handleSubmit={handleSubmit}
          error={error}
        />}
      />
      <StyledTable
        size="16"
        className="access-level-table"
      >
        <StyledTableHead
          col="5"
          className="access-level-table__head"
        >
          <StyledCol>{t("details.connections.project")}:</StyledCol>
          <StyledCol>{t("details.connections.name")}:</StyledCol>
          <StyledCol>{t("details.connections.payment")}:</StyledCol>
          <StyledCol>{t("details.connections.payout")}:</StyledCol>
          <StyledCol>{t("details.connections.createdAt")}:</StyledCol>
        </StyledTableHead>
        {connections.map((connection, key) => (
          <StyledTableRow
            col="5"
            className="access-level-table__row"
            key={key}
          >
            <StyledCol data-title="details.name">
              {connection.project.name}
            </StyledCol>
            <StyledCol data-title="details.name">
              {connection.name}
            </StyledCol>
            <StyledCol>
              <MaterialSwitch
                checked={connection.enablePayment}
                onChange={event => {
                  setChangeConnection({ ...changeConnection, id: connection.id, enablePayment: event.target.checked });
                  setOpen(true);
                }}
                name={connection.name}
              />
            </StyledCol>
            <StyledCol>
              <MaterialSwitch
                checked={connection.enablePayout}
                onChange={event => {
                  setChangeConnection({ ...changeConnection, id: connection.id, enablePayout: event.target.checked });
                  setOpen(true);
                }}
                name={connection.name}
              />
            </StyledCol>
            <StyledCol data-title="details.createdAt">
              {TimestampToDateMoment(connection.createDate)}
            </StyledCol>
          </StyledTableRow>
        ))}
      </StyledTable>
    </>
  );
};

export default ConnectionsList;